import axios from "axios";
import { BACK_RECIBO_ACTA } from "../utils/const";

export const getRecibo = async (numero_acta, setRecibo, setFile, setQrLink, setIsLoading, setError) => {
  setIsLoading(true);
  try {
    const result = await axios.post(
      `${BACK_RECIBO_ACTA}/obtener_recibo`,
      { numero_acta },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const { data } = result.data;
    if (data) {
      // console.log(data);
      if (data.recibo.qrLink) {
        setQrLink(data.recibo.qrLink);
      } else {
        setQrLink(-1);
      }
      setRecibo(data);
    }
  } catch (error) {
    setError(true);
  }
  setIsLoading(false);
  return;
};
